import { render, staticRenderFns } from "./PercentageInput.vue?vue&type=template&id=2f532006&scoped=true&"
import script from "./PercentageInput.vue?vue&type=script&lang=js&"
export * from "./PercentageInput.vue?vue&type=script&lang=js&"
import style0 from "./PercentageInput.vue?vue&type=style&index=0&id=2f532006&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f532006",
  null
  
)

export default component.exports